export default __webpack_public_path__ + "static/media/DIBS.37ddfa70.png";